import { MyIcon } from 'ccs-ui-components';
import { useTranslation } from 'react-i18next';
import classes from './InfoMessage.module.scss';

interface IInfoMessageProps {
  message: string
  onHighlightFieldClick: () => void
}
const InfoMessage = ({ message, onHighlightFieldClick }: IInfoMessageProps) => {
  const { t: translate } = useTranslation();

  const handleClick = () => {
    onHighlightFieldClick();
  };
  return (
    <div className={classes.container}>
      <MyIcon name="infoFillIcon" className={classes.icon} />
      <div className={classes.message}>{translate(message)} <button type="button" className={classes['link-button']} onClick={handleClick}>{translate('info_message.msg_highlight')}</button></div>
    </div>
  );
};

  export default InfoMessage;
